import { SearchControlled } from '@app/components/Search';
import { HStack, VStack, Box } from '@chakra-ui/react';
import { DropdownMenu } from '@app/components/DropdownMenu';
import React, { FC } from 'react';
import s from './SpNFTFilter.module.scss';
import {
  AUCTION_STATUS_OPTIONS,
  AUCTION_TYPE_OPTIONS
} from '@app/screens/nft-marketplace/SpNFTFilter/helpers';
import { useRewardNftsMarketplaceFiltersState } from '@app/state/rewardsNftsMarketplaceFiltersStore';

const PRICE_AND_LISTING_OPTIONS = [
  { title: 'Price low to high', value: 'asc' },
  { title: 'Price high to low', value: 'desc' }
  // { title: 'Recently listed', value: '2' },
  // { title: 'Recently sold', value: '3' },
  // { title: 'Ending soon', value: '4' }
];

type Props = {
  isMobile?: boolean;
};

export const RewardNftsFilter: FC<Props> = ({ isMobile }) => {
  const {
    searchTerm,
    sortOrder,
    auctionType,
    auctionStatus,
    actions: { setSearchTerm, setSortOrder, setAuctionType, setAuctionStatus }
  } = useRewardNftsMarketplaceFiltersState();

  return (
    <>
      {isMobile ? (
        <VStack paddingTop="18px" alignItems="center" gap="16px" mb={6}>
          <HStack width="100%" paddingTop="32px" flexWrap="wrap" gap="16px">
            <Box minWidth="160px" width="100%">
              <SearchControlled
                onSearch={val => setSearchTerm(val)}
                value={searchTerm}
              />
            </Box>
            <DropdownMenu
              classes={{
                dropdownContent: s.dropdownContent,
                dropdownContainer: s.dropdownContainer,
                heading: s.heading,
                dropdownAnimationContainer: s.dropdownAnimationContainer,
                dropdownLink: s.dropdownLink,
                onActive: { heading: s.headingActive }
              }}
              onSelect={val => setAuctionType(val)}
              title="Auction Type"
              items={AUCTION_TYPE_OPTIONS}
              selected={auctionType}
            />
            <DropdownMenu
              classes={{
                dropdownContent: s.dropdownContent,
                dropdownContainer: s.dropdownContainer,
                heading: s.heading,
                dropdownAnimationContainer: s.dropdownAnimationContainer,
                dropdownLink: s.dropdownLink,
                onActive: { heading: s.headingActive }
              }}
              onSelect={val => setAuctionStatus(val)}
              title="Auction Status"
              items={AUCTION_STATUS_OPTIONS}
              selected={auctionStatus}
            />
            <DropdownMenu
              classes={{
                dropdownContent: s.dropdownContent,
                dropdownContainer: s.dropdownContainer,
                heading: s.heading,
                dropdownAnimationContainer: s.dropdownAnimationContainer,
                dropdownLink: s.dropdownLink,
                onActive: { heading: s.headingActive }
              }}
              onSelect={val => {
                setSortOrder(val);
              }}
              items={PRICE_AND_LISTING_OPTIONS}
              selected={sortOrder}
            />
          </HStack>
        </VStack>
      ) : (
        <HStack paddingTop="18px" alignItems="flex-end" gap="16px" mb={6}>
          <Box>
            <SearchControlled
              onSearch={val => setSearchTerm(val)}
              value={searchTerm}
            />
          </Box>
          <VStack gap="8px" alignItems="flex-start">
            <DropdownMenu
              classes={{
                dropdownContent: s.dropdownContent,
                dropdownContainer: s.dropdownContainer,
                heading: s.heading,
                dropdownAnimationContainer: s.dropdownAnimationContainer,
                dropdownLink: s.dropdownLink,
                onActive: { heading: s.headingActive }
              }}
              onSelect={val => setAuctionType(val)}
              title="Auction Type"
              items={AUCTION_TYPE_OPTIONS}
              selected={auctionType}
            />
          </VStack>
          <VStack gap="8px" alignItems="flex-start">
            <DropdownMenu
              classes={{
                dropdownContent: s.dropdownContent,
                dropdownContainer: s.dropdownContainer,
                heading: s.heading,
                dropdownAnimationContainer: s.dropdownAnimationContainer,
                dropdownLink: s.dropdownLink,
                onActive: { heading: s.headingActive }
              }}
              onSelect={val => setAuctionStatus(val)}
              title="Auction Status"
              items={AUCTION_STATUS_OPTIONS}
              selected={auctionStatus}
            />
          </VStack>
          <VStack gap="8px" alignItems="flex-start">
            <DropdownMenu
              classes={{
                dropdownContent: s.dropdownContent,
                dropdownContainer: s.dropdownContainer,
                heading: s.heading,
                dropdownAnimationContainer: s.dropdownAnimationContainer,
                dropdownLink: s.dropdownLink,
                onActive: { heading: s.headingActive }
              }}
              onSelect={val => {
                setSortOrder(val);
              }}
              items={PRICE_AND_LISTING_OPTIONS}
              selected={sortOrder}
            />
          </VStack>
        </HStack>
      )}
    </>
  );
};
